import React from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import Root from "./Root";
import { registerApplication, start } from "single-spa";
import { purgeLegacyTokenStorage } from "./utils/legacyTokenStorage";
import "./styles/global.scss";

purgeLegacyTokenStorage();

// Register the applications
registerApplication({
  name: "@Optimizely/pim-argo-dashboard",
  app: () => System.import("@Optimizely/pim-argo-dashboard") as any,
  activeWhen: (location) => location.pathname.startsWith("/dashboard"),
  customProps: {
    containerId: "pim-argo-dashboard-container",
  },
});

registerApplication({
  name: "root",
  app: () => Promise.resolve(lifecycles),
  activeWhen: (location) => location.pathname.startsWith("/"),
});

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    return <div>Error occurred: {err.message}</div>;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;

// Start single-spa
window.addEventListener("load", () => {
  console.log("Starting single-spa...");
  start();
});
